import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
    iconContainer: {
        width: '100%',
        textAlign: 'center',
    },
    emailIcon: {
        margin: '2rem auto',
    },
});
